import { styled } from '@mui/material/styles';
import ExpandLessIcon from '@mui/icons-material/ExpandLess';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { MoveIcon } from 'assets/images/icons';
import { Typography } from '@components/Typography';

export const BuilderCard = styled('div', {
    shouldForwardProp: prop => prop !== 'isExpanded' && prop !== 'nested' && prop !== 'hasError',
})(({ isExpanded, hasError }) => ({
    padding: isExpanded ? '4px 16px 16px' : '4px 16px',
    marginBottom: 8,
    backgroundColor: '#fff',
    boxShadow: 'none',
    border: `1px solid ${hasError ? 'var(--error-main)' : 'var(--divider)'}`,
    borderRadius: 8,
    position: 'relative',
}));

const Header = styled('div')({
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    marginBottom: 15,
    cursor: 'pointer',
});

export const BuilderCardHeader = ({ caption, title, isExpanded, hasError, onToggle, listeners, attributes }) => (
    <Header onClick={onToggle}>
        <div style={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
            <span {...listeners} {...attributes} style={{ cursor: 'grab' }} onClick={e => e.stopPropagation()}>
                <MoveIcon />
            </span>
            <div style={{ display: 'flex', flexDirection: 'column', marginLeft: 16 }}>
                <Typography
                    variant="caption"
                    sx={{ color: hasError ? 'var(--error-main)' : 'var(--text-secondary)', margin: '4px 0 8px' }}
                >
                    {caption}
                </Typography>
                <Typography variant="body2" sx={{ fontWeight: '500 !important', minHeight: '1.43em' }}>
                    {title || ' '}
                </Typography>
            </div>
        </div>
        {isExpanded ? (
            <ExpandLessIcon className="sidebar-menu-arrow" />
        ) : (
            <ExpandMoreIcon className="sidebar-menu-arrow" />
        )}
    </Header>
);
